export enum TrainingSessionType{
    ZERO,
    SCENARIO,
    ONBOARDING,
    GROUPED,
    LARGEGROUP
}
